import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Grid } from '@material-ui/core';
import MUITableLoading from 'components/MUITableLoading/MUITableLoading';
import Layout from 'components/Layout/Layout';
import { useQuery } from '@apollo/client';
import { GET_CM_AND_EDITORS } from '../../../queries/user';
import Delete from './delete';
import DrawerNative from '../../../components/DrawerNative';
import PageError from '../../../components/PageError';
import PageTitle from '../../../components/PageTitle/PageTitle';
import AddUsers from './create';
import UpdateUsers from './edit';

export const Users = () => {
  const { data, loading, error } = useQuery(GET_CM_AND_EDITORS, { fetchPolicy: 'cache-first' });

  const users = data?.usersContentManagersOrEditors;

  const options = {
    selectableRows: 'none',
    responsive: 'scrollMaxHeight',
    customToolbarSelect: selectedRows => (
      <Delete selectedRows={selectedRows} users={users} />
    ),
  };

  const ActionsRow = (tableMeta) => {
    const id = tableMeta.rowData[1];
    const name = tableMeta.rowData[0];
    const email = tableMeta.rowData[2];
    const password = tableMeta.rowData[3];
    const role = tableMeta.rowData[4];
    const owner = tableMeta.rowData[5];
    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <DrawerNative title="Edit User" showBtn iconButtonAction={false} labelButtonAction={name}>
            <UpdateUsers id={id} name={name} email={email} password={password} role={role} owner={owner} />
          </DrawerNative>
        </Grid>
        <Grid item xs={6} />
      </Grid>
    );
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Users" />
        </Grid>
        <Grid item xs={2}>
          <DrawerNative title="User" showBtn labelButtonAction="Add">
            <AddUsers />
          </DrawerNative>
        </Grid>
      </Grid>
      {
        (loading) ? <MUITableLoading selectable="none" columns={['NAME', 'EMAIL', 'ROLE']} />
          : (error) ? <PageError />
            : (
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <MUIDataTable
                    title={false}
                    data={users}
                    columns={[
                      {
                        name: 'name',
                        label: 'NAME',
                        options: {
                          customBodyRender: (value, tableMeta) => ActionsRow(tableMeta),
                          empty: true,
                          filter: true,
                          sort: true,
                        },
                      }, {
                        name: 'id',
                        label: 'ID',
                        options: {
                          display: false,
                        },
                      },
                      {
                        name: 'email',
                        label: 'EMAIL',
                      },
                      {
                        name: 'password',
                        label: 'PASSWORD',
                        options: {
                          display: false,
                        },
                      }, {
                        name: 'role',
                        label: 'ROLE',
                        options: {
                          display: true,
                        },
                      },
                      {
                        name: 'owner',
                        label: 'OWNER',
                        options: {
                          display: false,
                        },
                      },
                    ]}
                    options={options}
                  />
                </Grid>
              </Grid>
            )
      }
    </Layout>
  );
};
